import React from 'react';

import { ExtraGym as ExtraGymType } from '../../types/ExtraGym';

import styles from './ExtraGym.module.scss';
import { WebpImageWithFallback } from '@husslehq/ui-library';
import { StarFull } from '../Icons';
import { Link } from 'react-alice-carousel';

export type ExtraGymProps = {
  gym: ExtraGymType;
};

export const ExtraGym: React.FC<ExtraGymProps> = ({ gym }) => {
  // Fix image sizes as best possible for the design
  const thumbnailSize = { width: 640, height: 480 };
  const imageSize = { width: 273, height: 197 };
  const imageRatio = imageSize.width / thumbnailSize.width;
  imageSize.height = thumbnailSize.height * imageRatio;

  return (
    <div className={styles.gym}>
      <Link href={gym.Url}>
        <WebpImageWithFallback
          alt={'Photo of ' + gym.Name}
          className={styles.gym__image}
          src={gym.ImageThumbGym}
          loading="eager"
          width={String(imageSize.width)}
          height={String(imageSize.height)}
        />
        <div className={styles['gym__rating-container']}>
          <div className={styles['gym__rating-star']}>
            <StarFull />
          </div>
          <div className={styles['gym__rating-rating']}>
            {Math.round(Number(gym.Reviews.Average) * 10) / 10} ({gym.Reviews.Total})
          </div>
        </div>
        <h4>{gym.Name}</h4>
      </Link>
    </div>
  );
};
